import { useSelect, useDispatch } from '@wordpress/data';
import { Button } from '@wordpress/components';
import { useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { applyFilters } from '@wordpress/hooks';
import './style.scss';

const CustomPublishPreviewButtons = () => {
    const [buttonText, setButtonText] = useState('');
    const {
        isPublishable,
        isSaveable,
        isPublished,
        isSaving,
        previewLink,
    } = useSelect((select) => {
        const editor = select('core/editor');

        return {
            isPublishable: editor.isEditedPostPublishable(),
            isSaveable: editor.isEditedPostSaveable(),
            isPublished: editor.isCurrentPostPublished(),
            isSaving: editor.isSavingPost(),
            previewLink: editor.getEditedPostPreviewLink(),
        };
    }, []);

    const { savePost } = useDispatch('core/editor');

    useEffect(() => {
        if (isSaving) {
            setButtonText(__('Saving...', 'cv-builder'));
        } else {
            setButtonText(isPublished ? __('Saved', 'cv-builder') : '');
        }
    }, [isSaving, isPublished]);

    const isButtonEnabled = !isSaving && isPublishable && isSaveable;

    const handlePreview = () => {
        if (previewLink) {
            window.open(previewLink, '_blank');
        }
    };
    const siteIcon = applyFilters('bwdcv.siteIcon', null);
    return (
        <div className="my-custom-buttons-container">
            {siteIcon}
            <Button
                isSecondary
                href={userData.dashboardUrl}
                target="_blank"
                className="myaccount-button"
            >
                {__('Dashboard', 'cv-builder')}
            </Button>
            <Button
                isPrimary
                href={userData.pageSlug}
                target="_blank"
                onClick={handlePreview}
                className="preview-button"
            >
                {__('Preview & Download', 'cv-builder')}
            </Button>
            <Button
                isPrimary
                onClick={() => savePost()}
                disabled={!isButtonEnabled}
                className="publish-button-wrapper"
            >
                <span className="button-text">{buttonText}</span>
            </Button>
        </div>
    );
};

export default CustomPublishPreviewButtons;
